import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { CartProvider } from "@/contexts/CartContext";
import Layout from "@/components/Layout";
import Inicio from "@/pages/Inicio";
import Productos from "@/pages/Productos";
import Produccion from "@/pages/Produccion";
import Logistica from "@/pages/Logistica";
import Tienda from "@/pages/Tienda";
import Eventos from "@/pages/Eventos";
import Contacto from "@/pages/Contacto";
import PoliticaPrivacidad from "@/pages/PoliticaPrivacidad";
import TerminosCondiciones from "@/pages/TerminosCondiciones";
import PoliticaCookies from "@/pages/PoliticaCookies";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <CartProvider>
          <BrowserRouter>
            <Layout>
              <Routes>
                <Route path="/" element={<Inicio />} />
                <Route path="/productos" element={<Productos />} />
                <Route path="/produccion" element={<Produccion />} />
                <Route path="/logistica" element={<Logistica />} />
                <Route path="/tienda" element={<Tienda />} />
                <Route path="/eventos" element={<Eventos />} />
                <Route path="/contacto" element={<Contacto />} />
                <Route path="/politica-privacidad" element={<PoliticaPrivacidad />} />
                <Route path="/terminos-condiciones" element={<TerminosCondiciones />} />
                <Route path="/politica-cookies" element={<PoliticaCookies />} />
                <Route path="*" element={<Inicio />} />
              </Routes>
            </Layout>
          </BrowserRouter>
        </CartProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
